"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shape = void 0;
/**
 * Shapes. See options and defaults at https://mui.com/material-ui/customization/default-theme/
 */
exports.shape = {
    borderRadius: 3,
};
